<template>
    <div class="printContainerMulti transparent">
        <div style="width: 19cm; margin: auto; overflow-x: hidden">
            <div class="text-center title mt-7">Vereinsdatenblätter</div>
            <div v-for="(page, i) in vereinsdatenblaetter" :key="i"
                 class="pageBreak d-flex flex-wrap mt-5">
                <div v-for="(datenblatt, j) in page" :key="j"
                     class="d-inline-block mb-5"
                     style="width: 48%; margin-left: 2%">
                    <div class='text-center py-1 font-weight-bold text-truncate'
                         style="font-size: 12px">
                        {{datenblatt.vereinsName}} ({{datenblatt.vereinsNr}})
                    </div>
                    <vereinsdatenblatt-team :vereinsdatenblatt="datenblatt.data"
                                            small-print="true" small="true">
                    </vereinsdatenblatt-team>
                </div>
            </div>
        </div>
    <!-- navigation box -->
        <div style="position: fixed; width: 27cm; top: 0; left: 0; height: 300px;
                        right: 0; margin: auto">
            <v-btn fab dark bottom right
                   color="primary" style="position: absolute; right: 90px; top: 15px; z-index: 15"
                   @click="openPrint()">
                <v-icon >mdi-printer</v-icon>
            </v-btn>
        </div>
    </div>
</template>

<script>
    import {db} from "../../../services/db";
    import VereinsdatenblattTeam from "./vereinsdatenblattTeam";
    export default {
        components: {VereinsdatenblattTeam},
        name: "vereinsdatenblatt-print",
        data: () => ({
            list: [],
        }),
        computed: {
            vereinsdatenblaetter(){
                let list = this.list;
                list.sort((a, b) => a.vereinsName > b.vereinsName ? 1 : -1);
                let i = 1;
                let pages = [];
                let page = [];
                list.forEach( (item) => {
                    page.push(item);
                    if ( i === 4 ) {
                        pages.push(page);
                        page = [];
                        i = 0;
                    }
                    i++;
                });
                if ( i !== 1 ) {
                    pages.push(page);
                }
                return pages;
            }
        },
        created(){
            this.readFromQuery();
            setTimeout( () => {this.getVereinsdatenBlaetter();}, 500);
        },
        methods: {
            readFromQuery(){
                const listTemp = this.$route.query.get.split('_');
                listTemp.forEach( (item) => {
                    this.list.push(
                        {vereinsNr: item.substr(0,5), vereinsName: item.substr(5), data: null}
                    )
                });
            },
            getVereinsdatenBlaetter(){
                console.log ("getVereinsdatenBlaetter");
                this.list.forEach( (team) => {
                    db.collection("vereinsdatenblaetter")
                        .doc(team.vereinsNr)
                        .get().then((doc) => {
                            if (doc.exists) {
                                this.list.find(team => team.vereinsNr === doc.id).data = doc.data();
                            } else {
                                team.data = null;
                            }
                    }).catch((error) => {
                        console.log("Error getting document:", error);
                    });
                });
            },
            openPrint(){
                window.print()
            }
        },
    }
</script>

<style scoped>
    @media print{@page {size: portrait; margin: 0}}
    .pageBreak {
        page-break-after: always;

    }
    .printContainerMulti { position: relative; width: 100%;
        z-index: 20; overflow: auto;
        font-family: verdana, arial, helvetica;}

</style>